module.exports = __webpack_public_path__ + "img/36.945f9711.png";